/**
 * Determines if a user is targeted for benefits-focused features.
 */
export function isBenefitsTargeted(
  features: string[] | null | undefined,
): boolean {
  return (
    features?.includes("MAXIMIZE_BENEFITS") === true &&
    !features?.includes("FIX_BILLING_ERRORS")
  );
}
